import { render, staticRenderFns } from "./PainelSaldoAnualContratos.vue?vue&type=template&id=7d6c96fb"
import script from "./PainelSaldoAnualContratos.vue?vue&type=script&lang=js"
export * from "./PainelSaldoAnualContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports